import Area from '@/components/Area';
import { useAspect, useTexture, useVideoTexture, OrbitControls } from '@react-three/drei';
import { Canvas } from '@react-three/fiber';
import * as React from 'react';
import srcThumbnail from './10.jpg.chunk';
import srcVideo from './10.mp4.chunk';

console.log({ srcThumbnail, srcVideo });

function VideoMaterial({ url }: { url: string }) {
  const texture = useVideoTexture(url);
  return (
    <meshBasicMaterial
      map={texture}
      toneMapped={false}
      side={2} // DoubleSide
      transparent={true}
      depthWrite={false}
      depthTest={false}
      color={0xffffff}
      alphaTest={0.5}
    />
  );
}

function ImageTexture({ url }: { url: string }) {
  const texture = useTexture(url);
  return (
    <meshBasicMaterial
      map={texture}
      toneMapped={false}
      side={2} // DoubleSide
      transparent={true}
      depthWrite={false}
      depthTest={false}
      color={0xffffff}
      alphaTest={0.5}
    />
  );
}

function Scene() {
  const size = useAspect(1800, 1000);
  // console.log('Scene', { size });
  return (
    <mesh scale={size}>
      <planeGeometry />
      <React.Suspense fallback={<ImageTexture url={srcThumbnail} />}>
        <VideoMaterial url={srcVideo} />
      </React.Suspense>
    </mesh>
  );
}

export type Props = {};

function App01(props: Props) {
  const {} = props;

  return (
    <Area>
      {() => (
        <Canvas>
          <Scene />
          <OrbitControls makeDefault />
        </Canvas>
      )}
    </Area>
  );
}

export default React.memo(App01);
